module.exports = __webpack_public_path__ + "segment-logo-b76243f0d7ba776de119a0bfc15b8aee.webp";